<template>
<div class="left-content">
  <div v-if="videoList.length !== 0">
    <div class="title">
      特等大师奖(5位)
    </div>
    <div class="award">{{$t('global.奖励')}}
      <span>¥1000，000</span>{{$t('global.元')}}</div>
    <div class="allproduct">
      <div class="videoCreation" v-for="(item, index) in videoList" :key="index">
        <video-creation :info="item"></video-creation>
      </div>
    </div>
  </div>
  <div v-if="videoList.length === 0" class="noContent">
    <img src="/static/activity/noContent.png" alt="">
    <div>{{$t('global.获奖作品')}}，{{$t('global.敬请期待')}}</div>
  </div>
</div>
</template>

<script>
import VideoCreation from "@/components/activity/VideoCreation";

export default {
  components: {
    VideoCreation
  },

  data() {
    return {
      videoList: []
    };
  },

  watch: {
    $route: function() {
      let currentID = this.$route.params.id;
      if (currentID == this.detailData.id) return;
      this.getData(this.$route.params.id);
    }
  },

  methods: {
    getData(activityId) {
      this.$http
        .get("/api/activity/prizeList", {
          params: {
            activityId,
          }
        })
        .then(data => {
          let d = data.data;
          this.videoList = d;
        });
    }
  },

  created() {
    this.getData(this.$route.params.id);
  }
};
</script>

<style lang="stylus" scoped>
.allproduct {
  display: flex;
  flex-wrap: wrap;
}

.videoCreation {
  width: 3.42rem;
  margin: 0.2rem 0.18rem 0 0;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #d5d5d5;
  border-radius: 0.08rem;

  &:nth-child(3n) {
    margin-right: 0;
  }
}

.left-content {
  width: 10.8rem;
  margin-top: 0.2rem;
  padding: 0.4rem 0.6rem;
  background-color: #ffffff;

  .title {
    color: #333333;
    font-size: 0.26rem;
    margin-top: 0.3rem;
    text-align: center;
  }

  .award {
    font-size: 0.26rem;
    color: #707070;
    text-align: center;
    margin: 0.2rem 0 0.4rem 0;

    span {
      color: #ff0000;
    }
  }

  .noContent {
    img {
      display: block;
      width: 1.83rem;
      height: 1.59rem;
      margin: 0.6rem auto 0;
    }

    div {
      font-size: 0.26rem;
      color: #cccccc;
      margin: 0.39rem 0;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/match/WinningWorks.vue